import { Grid, IconButton, InputAdornment, OutlinedInput, TextField } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import LabelsContext from "../../../lang/LabelsContext";
import KeywordsDto from "../../../model/keywords/KeywordsDto";
import KeywordsService, { KeywordsServiceType } from "./KeywordsService";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useStyles from "./KeywordsStyle";
import CancelIcon from "@material-ui/icons/Cancel";

export default function Keywords() {
  const classes = useStyles();
  const { Labels } = LabelsContext();

  const {
    keywordsList,
    keywordState,
    setKeywordState,
    openDialog,
    setOpenDialog,
    addKeyword,
    deleteKeyword,
    updateKeyword,
    searchText,
    setSearchText,
  }: KeywordsServiceType = KeywordsService();

  return (
    <>
      <CssBaseline />
      <div className={classes.container}>
        <Grid container justifyContent="space-between">
          <Grid item xs={12} sm={6}>
            <Grid container spacing={2} alignItems={"flex-end"}>
              <Grid item>
                <Typography variant="h5">{Labels.KEYWORDS}</Typography>
              </Grid>
              <Grid item alignItems={"flex-end"}>
                <Button
                  className={classes.addKeyword}
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setKeywordState(null);
                    setOpenDialog(true);
                  }}
                >
                  {Labels.ADD_KEYWORD}
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.search}>
            <OutlinedInput
              placeholder={Labels.SEARCH_KEYWORD}
              id="searchText"
              name="searchText"
              value={searchText}
              onChange={(e: any) => setSearchText(e.target.value)}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => setSearchText("")} edge="end">
                    <CancelIcon />
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
        </Grid>
        <Grid container>
          {keywordsList.map((obj: KeywordsDto) => {
            const { id, keyword } = obj;
            return (
              <Grid key={id} item xs={12} sm={3}>
                <Card className={classes.root}>
                  <CardActionArea>
                    <CardContent className={classes.cardContent}>
                      <Typography variant="subtitle1">{keyword}</Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions className={classes.cardAction}>
                    <Grid container justifyContent="flex-end" alignItems="flex-end">
                      <IconButton
                        onClick={() => {
                          setKeywordState(obj);
                          setOpenDialog(true);
                        }}
                        className={classes.button}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton onClick={() => deleteKeyword(id)} className={classes.button}>
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </CardActions>
                </Card>
              </Grid>
            );
          })}
        </Grid>
        <Dialog
          open={openDialog}
          maxWidth={"sm"}
          fullWidth={true}
          onClose={() => setOpenDialog(false)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            {keywordState?.id ? Labels.EDIT_KEYWORD : Labels.NEW_KEYWORD}
          </DialogTitle>
          <DialogContent>
            <TextField
              variant="outlined"
              margin="normal"
              name="keyword"
              value={keywordState?.keyword}
              onChange={(e: any) => setKeywordState({ ...keywordState, keyword: e.target.value })}
              label={Labels.KEYWORD}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="primary">
              {Labels.CANCEL}
            </Button>
            <Button
              onClick={() => {
                keywordState.id ? updateKeyword(keywordState) : addKeyword(keywordState);
                setOpenDialog(false);
              }}
              color="primary"
              variant={"contained"}
            >
              {Labels.SAVE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
